module.exports = __webpack_public_path__ + "static/media/templateone1.bc63ee95.png";